// Types
export * from "./types/reference-data"
export * from "./types/core"

// Builders — same filenames as original services
export * from "./builders/save-countries-to-search"
export * from "./builders/save-countries-v2-to-search"
export * from "./builders/save-ref-item-to-search"
export * from "./builders/save-ref-item-history-to-search"
export * from "./builders/save-ref-field-to-search"
export * from "./builders/save-ref-unit-to-search"
export * from "./builders/save-ref-caption-to-search"
export * from "./builders/save-ref-list-to-search"
export * from "./builders/save-port-to-search"
export * from "./builders/save-un-locode-to-search"
export * from "./builders/save-language-to-search"
export * from "./builders/save-eu-ingredients-to-search"
export * from "./builders/save-wine-colours-to-search"
export * from "./builders/save-wine-styles-to-search"
export * from "./builders/save-wine-grape-varieties-to-search"
export * from "./builders/save-wine-geographic-indications-to-search"
export * from "./builders/save-wine-eu-categories-to-search"
export * from "./builders/save-ref-process-to-search"
export * from "./builders/save-ref-process-group-to-search"
export * from "./builders/save-ref-process-group-caption-to-search"
export * from "./builders/save-ref-phyto-botanical-name-to-search"
export * from "./builders/save-package-types-to-search"
export * from "./builders/save-bottle-sizes-to-search"
export * from "./builders/save-transfer-request-to-search"
export * from "./builders/save-transfer-products-to-search"
export * from "./builders/save-export-certificates-to-search"
export * from "./builders/save-ec-b2g-to-search"
export * from "./builders/save-supporting-document-to-search"
export { getRegistrationRequestData, saveRegistrationToSearch } from "./builders/save-registrations-to-search"
export type { RegistrationDoc } from "./builders/save-registrations-to-search"
export { getAgencyData, saveAgencyToSearch } from "./builders/save-agency-to-search"
export type { AgencyDoc } from "./builders/save-agency-to-search"
export * from "./builders/save-template-to-search"

// Utils
export { extractProductFields } from "./utils/extract-product-fields"
export { getTransferRequest, getCountryInfoByCode, getTemplateInfoByVersionId } from "./utils/db-helpers"
export { searchBuilderLog } from "./utils/logger"

// Registry
export * from "./registry/collection-registry"
export { getCollectionSchema, getCollectionSchemaWithPrefix, getAllSchemaNames, collectionAlias } from "./registry/schema-registry"
export { resolveForeignPremisesId } from "./utils/supporting-documents-helper"

// Collection Schemas — Typesense CollectionCreateSchema definitions
export * from "./schemas"
